import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-grid p-fluid" }
const _hoisted_2 = { class: "col-md-12" }
const _hoisted_3 = { class: "col-md-12" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = {
  class: "table align-middle table-row-dashed fs-6 fw-bold gy-4",
  id: "kt_subscription_products_table"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-muted fw-bolder fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Toplam Sevk Miktarı"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Toplam Sevk Tutarı"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Yükleme Tarihi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "Sevk Tarihi"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px" }, "İşlemler")
  ])
], -1)
const _hoisted_7 = { class: "text-gray-600" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "indicator-label svg-icon svg-icon-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)

import { ref, withDefaults } from "vue";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { Field } from "vee-validate";
import Modal from "@/components/Modal.vue";
import { useToast } from "primevue/usetoast";
import AddShipping from "./AddShipping.vue";
import EditShipping from "./EditShipping.vue";
import moment from "moment";
import JwtService from "@/core/services/JwtService";
export interface PropsModel {
  id: number;
  isActive: boolean;
  name: string;
  data: any;
  sizeRows: any;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ListShipping',
  props: {
    id: { default: 0 },
    isActive: { type: Boolean, default: false },
    name: { default: undefined },
    data: { default: null },
    sizeRows: { default: null }
  },
  emits: ["changeReceipt", "changeDate"],
  setup(__props: any, { emit }) {

const props = __props as { id: number, isActive: boolean, name: string, data: any, sizeRows: any }

const updateButtonDisabled = ref(false);


const isActive = ref(props.isActive);
const toast = useToast();
const addShippingIsActive = ref(false);
const editShippingIsActive = ref(false);
const store = useStore();
const differenceReasonName = ref(props.name);
const editData = ref();
const toggleModal = (args) => {
  addShippingIsActive.value = !addShippingIsActive.value;
};
const toggleEditModal = (args) => {
store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  editShippingIsActive.value = !editShippingIsActive.value;
  if (args) {
    editData.value = args;
      
store.dispatch(Actions.DELIVERY_LINE_LIST, args.id).then((f) => {
  store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
});
  } else {
    editData.value = null;
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  }
};

const onChange = (args) => {
  store.dispatch(Actions.ORDER_DETAIL, store.state.OrderModule.order.value.id);
  emit("changeReceipt", args);
};
const saveChanges = () => {
  store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
  updateButtonDisabled.value = true;
  var model = {
    id: props.id,
    name: differenceReasonName.value,
  };
  store.dispatch(Actions.UPDATE_DIFFERENCE_REASON, model).then((x) => {
    if (x.success) {
      toast.add({
        severity: "success",
        summary: "İşlem Sonucu",
        detail: x.message,
        life: 3000,
      });
      store.dispatch(Actions.DIFFERENCE_REASON_LIST);
      updateButtonDisabled.value = false;
    } else {
      toast.add({
        severity: "error",
        summary: "İşlem Sonucu",
        detail: x.message,
        life: 3000,
      });
      updateButtonDisabled.value = false;
    }
    store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
  });
};
const deleteDelivery = (args) => {
  Swal.fire({
    title: "İlgili kayıt silinsin mi?",
    text: "Emin misiniz? Bu işlemi geri alamazsınız!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    confirmButtonText: "Evet, Sil!",
    cancelButtonText: "İptal",
  }).then((result) => {
    // <--
    if (result.value) {
      // <-- if confirmed
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
      store
        .dispatch(Actions.REMOVE_DELIVERY, args)
        .then((x) => {
          store
            .dispatch(
              Actions.ORDER_DETAIL,
              store.state.OrderModule.order.value.id
            )
            .then((f) => {
              toast.add({
                severity: "success",
                summary: "İşlem Sonucu",
                detail: x.message,
                life: 3000,
              });
              store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
            });
        })
        .catch((e) => {
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
        });
    }
  });
};
const updateDate = (event) => {
  emit("changeDate", event);
};

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Modal, {
      onClose: onChange,
      modalActive: props.isActive,
      title: "Sevkiyat Listesi",
      closeIcon: false,
      width: "75vw"
    }, {
      default: _withCtx(() => [
        (JSON.parse(_unref(JwtService).getUser()).roles.find((x) => x.id != 3))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-light-primary",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleModal(false))),
              tabindex: "-1"
            }, " Yeni Sevkiyat "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("table", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("tbody", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.OrderModule.order.value.orderLines.find(
                    (f) => f.id == props.data.id
                  ).deliveries, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "odd",
                        key: index
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.totalQuantity), 1),
                        _createElementVNode("td", null, _toDisplayString(item.totalPrice) + " " + _toDisplayString(props.data.currency.symbol), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(moment)(item.shippingDate).format("DD.MM.YYYY")), 1),
                        _createElementVNode("td", null, _toDisplayString(_unref(moment)(item.deliveryDate).format("DD.MM.YYYY")), 1),
                        _createElementVNode("td", _hoisted_8, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-icon btn-flex btn-active-light-primary w-30px h-30px me-3",
                            "data-bs-toggle": "tooltip",
                            title: "",
                            onClick: ($event: any) => (toggleEditModal(item))
                          }, _hoisted_11, 8, _hoisted_9),
                          (JSON.parse(_unref(JwtService).getUser()).roles.find((x) => x.id != 3))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "btn btn-icon btn-flex btn-active-light-primary w-30px h-30px me-3",
                                onClick: ($event: any) => (deleteDelivery(item.id))
                              }, [
                                _createElementVNode("span", _hoisted_13, [
                                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen027.svg" })
                                ]),
                                _hoisted_14
                              ], 8, _hoisted_12))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modalActive"]),
    (addShippingIsActive.value)
      ? (_openBlock(), _createBlock(AddShipping, {
          key: 0,
          isActive: addShippingIsActive.value,
          onChangeAddShipping: toggleModal,
          shippingDetail: __props.data,
          sizeRows: props.sizeRows,
          order: props
        }, null, 8, ["isActive", "shippingDetail", "sizeRows"]))
      : _createCommentVNode("", true),
    (editShippingIsActive.value)
      ? (_openBlock(), _createBlock(EditShipping, {
          key: 1,
          isActive: editShippingIsActive.value,
          onChangeAddShipping: toggleEditModal,
          shippingDetail: __props.data,
          sizeRows: props.sizeRows,
          data: editData.value
        }, null, 8, ["isActive", "shippingDetail", "sizeRows", "data"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})